import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useLanguage } from '../contexts/LanguageContext';
import CategoryCard from '../components/CategoryCard';
import { Button } from '../components/ui/button';
import SEO from '../components/SEO';
import { ArrowLeft } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CategoriesPage = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${API}/categories`);
      setCategories(response.data);
    } catch (error) {
      console.error('Error fetching categories:', error);
    } finally {
      setLoading(false);
    }
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "Business Categories in Karur",
    "description": "Browse all business categories available in Karur",
    "url": "https://yourwebsite.com/categories"
  };

  return (
    <div className="min-h-screen bg-slate-50" data-testid="categories-page">
      <SEO
        title="All Business Categories | United Hands Karur Shop"
        description="Browse all business categories in Karur - restaurants, shops, services, healthcare, education, electronics and more. Find the right business type for your needs."
        keywords="Karur business categories, shop types Karur, business directory categories, Karur services list, types of businesses"
        structuredData={structuredData}
      />
      
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-600 to-blue-800 py-12">
        <div className="container mx-auto px-4 md:px-6">
          <Button
            variant="ghost"
            onClick={() => navigate(-1)}
            className="text-white hover:bg-white/20 mb-4"
            data-testid="back-btn"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            {t('home')}
          </Button>
          <h1 className="text-3xl md:text-4xl font-bold text-white font-['Manrope']">
            {t('allCategories')}
          </h1>
        </div>
      </div>

      {/* Categories Grid */}
      <div className="container mx-auto px-4 md:px-6 py-12">
        {loading ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
            {[...Array(12)].map((_, i) => (
              <div key={i} className="animate-pulse bg-white rounded-xl h-64" />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
            {categories.map((category) => (
              <CategoryCard key={category.id} category={category} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CategoriesPage;
